<template>
  <div class="">
    <sticky class="page-header sticky-page-header page-header--new"
            :back-button="true"
            :bigTotal="bigTotal"
            :loading="loading" :total="bigTotal"
            :label="'Mandat'">
      <router-link v-if="isAdmin" :to="{name: 'AccessCreate', query: {program: this.$route.query.program}}" class="dropdown-item" slot="dropdown-content">
        <span class="icon"><i class="fas fa-plus-circle"></i></span>
        <span>Nouveau Mandat</span>
      </router-link>
      <a @click="exportXls('accesses-export', query)" class="dropdown-item" slot="dropdown-content" v-if="!multiselection">
        <span class="icon"><i class="fas fa-file-excel"></i></span>
        <span>Exporter Mandats</span>
      </a>
      <a @click="loadItems()" class="dropdown-item" slot="dropdown-content">
        <span class="icon"><i class="fas fa-sync"></i></span>
        <span>Actualiser</span>
      </a>
      <a @click="deleteAccesses" class="has-text-danger dropdown-item" slot="dropdown-content" v-if="!multiselection && isAdmin">
        <span class="icon"><i class="fas fa-trash-alt"></i></span>
        <span>Supprimer tous les mandats</span>
      </a>
    </sticky>
    <div class="page-content columns collapseColumn collapseColumn--left collapseColumn--alignStart" id="columns-collapse"
         :class="opened ? 'is-active-collapse' : 'is-inactive-collapse'">
      <div class="column is-4 is-3-widescreen is-3-fullhd">
        <list-filter @resetFilters="resetFilters"
                     @changeFilters="changeFilters"
                     :total="total"
                     :bigTotal="bigTotal"
                     :loading="loading"
                     :hasFilter="hasFilter"
                     @opened="opened = !opened">
          <div class="columns">
            <div class="column is-paddingless-bottom is-padding-top-small">
              <div class="control">
                <multiselect @select="updateCompanyFilter" @remove="updateCompanyFilter(null)"
                            class="multiselect--option-ico is-single_choice"
                            v-model="filters.company" track-by="pk"
                            :options="companies" :searchable="true"
                            :custom-label="companyName" :show-labels="false" :placeholder="''"
                            @search-change="getCompanies">
                  <span slot="placeholder" class="multiselect__placeholder">Société</span>
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-paddingless-bottom is-padding-top-small">
              <div class="control">
                <multiselect @select="updateProgramFilter" @remove="updateProgramFilter(null)"
                            class="multiselect--option-ico is-single_choice"
                            v-model="filters.program" label="name" track-by="pk"
                            :options="programs" :searchable="true" :show-labels="false"
                            @search-change="getPrograms" :placeholder="''">
                  <template slot="clear" slot-scope="props">
                    <div class="multiselect__clear" v-if="programs.length"
                        @mousedown.prevent.stop="clearAll(props.search)"></div>
                  </template>
                  <span slot="placeholder" class="multiselect__placeholder">Programme</span>
                  <span slot="noResult">Oups! Aucun programme trouvé.</span>
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="columns" v-if="isDistributeurMode">
            <div class="column is-paddingless-bottom is-padding-top-small">
              <div class="control">
                <multiselect @select="updatePromoteurFilter" @remove="updatePromoteurFilter(null)"
                            class="multiselect--option-ico is-single_choice"
                            v-model="filters.promoteur" label="name" track-by="pk"
                            :options="promoteurs" :searchable="true" :show-labels="false"
                            @search-change="getPromoteurs" :placeholder="''">
                  <template slot="clear" slot-scope="props">
                    <div class="multiselect__clear" v-if="promoteurs.length"
                        @mousedown.prevent.stop="clearAll(props.search)"></div>
                  </template>
                  <span slot="placeholder" class="multiselect__placeholder">Promoteur</span>
                  <span slot="noResult">Oups! Aucun promoteur trouvé.</span>
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-paddingless-bottom is-padding-top-small">
              <div class="field has-addons">
                <div class="control">
                  <a class="button is-square is-static is-border is-square">
                    <span class="icon"><i class="fas fa-calendar-alt"></i></span>
                  </a>
                </div>
                <div class="control is-expanded">
                  <flat-pickr :config="configDate" v-model="filters.start_date__gte" class="input is-radiusless"
                          @input="changeFilters" placeholder="Début de mandat"
                          name="start_date"></flat-pickr>
                </div>
                <div class="control">
                  <a class="button is-square is-grey is-inverted is-border is-square" @click="filters.start_date__gte = null">
                    <i class="fal fa-times"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-padding-top-small">
              <div class="field has-addons">
                <div class="control">
                  <a class="button is-static is-border is-square">
                    <span class="icon"><i class="fas fa-calendar-alt"></i></span>
                  </a>
                </div>
                <div class="control is-expanded">
                  <flat-pickr :config="configDate" v-model="filters.end_date__lte" class="input is-radiusless" name="end_date"
                              placeholder="Fin de mandat"
                              @input="changeFilters"></flat-pickr>
                </div>
                <div class="control">
                  <a class="button is-grey is-inverted is-border is-square" @click="filters.end_date__lte = null">
                    <i class="fal fa-times"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </list-filter>
      </div>
      <div class="column is-8 is-9-widescreen is-9-fullhd">
        <div class="is-border">
          <div class="columns is-gapless row-width-actions-bar">
            <transition enter-active-class="animated fadeIn faster" leave-active-class="animated fadeOut faster" mode="out-in">
              <div class="column is-narrow has-bg-primary columns is-vcentered is-gapless" v-if="hasFilter && !loading && total !== bigTotal">
                <div class="column is-padding-left is-padding-right has-text-white">Résultat : {{total || 0}} mandat(s)</div>
              </div>
            </transition>
            <div class="column"></div>
            <div class="column is-narrow is-border-left"
              v-if="multiselection && selectedItems.length && askDelete">
              <a @click="deleteSelectedAccesses" class="page-header-btn is-small is-danger">
                <span>Confirmer suppression ({{selectedItems.length}} mandats)</span>
              </a>
            </div>
            <div class="column is-narrow is-border-left" v-if="multiselection && selectedItems.length">
              <a @click="askDelete = true" class="page-header-btn is-small is-square is-danger">
                <span class="icon"><i class="fas fa-trash"></i></span>
              </a>
            </div>
            <div class="column is-narrow is-border-left" v-if="!multiselection && isAdmin">
              <a @click="multiselection = !multiselection" data-tooltip="Sélection multiple"
                 class="page-header-btn is-small is-square tooltip is-tooltip-bottom is-tooltip-primary">
                <span class="icon"><i class="fas fa-tasks"></i></span>
              </a>
            </div>
            <div class="column is-narrow is-border-left" v-if="multiselection">
              <a @click="cancelMultiselect" class="page-header-btn is-small is-info is-square tooltip is-tooltip-bottom is-tooltip-primary"
                 data-tooltip="Annuler la sélection">
                <span class="icon"><i class="fas fa-tasks has-text-white"></i></span>
              </a>
            </div>
            <!-- <div class="column is-narrow is-border-left">
              <button class="page-header-btn is-square">
                <span class="icon"><i class="fas fa-sort-amount-up"></i></span>
              </button>
            </div> -->
          </div>
          <div class="">
            <table v-show="!loading && items.length" class="table is-fullwidth is-marginless-bottom is-first-fixed-small">
              <thead>
                <tr class="is-size-6">
                  <th class="is-paddingless has-text-centered actions">
                    <button v-if="multiselection" class="button is-small is-light is-circle" @click="selectItemToggleAll(items)">
                      <i class="far fa-check-double"></i>
                    </button>
                  </th>
                  <th>
                    <sortable @sort="sort('company_name', $event)" :sort="sortBy.company_name" label="Société"></sortable>
                  </th>
                  <th>
                    <sortable @sort="sort('program_name', $event)" :sort="sortBy.program_name" label="Programme"></sortable>
                  </th>
                  <th v-if="isDistributeurMode">
                    <sortable @sort="sort('promoteur_name', $event)" :sort="sortBy.promoteur_name" label="Promoteur"></sortable>
                  </th>
                  <th>
                    <sortable @sort="sort('start_date', $event)" :sort="sortBy.start_date" label="Date de début"></sortable>
                  </th>
                  <th>
                    <sortable @sort="sort('end_date', $event)" :sort="sortBy.end_date" label="Date de fin"></sortable>
                  </th>
                  <th v-if="displayRemuneration">
                    <sortable @sort="sort('remuneration', $event)" :sort="sortBy.remuneration"
                              label="Taux rémunération"></sortable>
                  </th>
                  <th v-if="isAdmin" class="has-text-centered" width="70px">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(access, index) in items" :key="access.pk" class="is-size-6">
                  <td class="is-cell-hoverable is-paddingless has-text-centered actions">
                    <span v-if="!multiselection"><avatar :item="access" :i="index"></avatar></span>
                    <multiselect-button v-else
                                        :data="access"
                                        :is-checked="checkedItem(access.pk)"
                                        :multiselection="multiselection"
                                        @selected="selectItem">
                    </multiselect-button>
                  </td>
                  <td class="is-cell-hoverable">
                    <router-link :to="{name: 'CompanyVue', params: {id: access.company}}">{{access.company_name}}</router-link>
                  </td>
                  <td class="is-cell-hoverable">
                    <router-link :to="{name: 'ProgramVue', params: {id: access.program}}">{{access.program_name}}</router-link>
                  </td>
                  <td v-if="isDistributeurMode">
                    <router-link v-if="access.promoteur" :to="{name: 'PromoteurVue', params: {id: access.promoteur}}">
                      {{access.promoteur_name}}
                    </router-link>
                    <span v-else>NC</span>
                  </td>
                  <td>{{access.start_date}}</td>
                  <td>{{access.end_date}}</td>
                  <td v-if="displayRemuneration">{{access.remuneration}} %</td>
                  <td v-if="isAdmin" class="has-text-centered actions">
                    <display-button-list :buttons="buttonList" :data="access"
                                        :openUp="{'position': index, 'total': items.length}">
                    </display-button-list>
                  </td>
                </tr>
                <tr class="empty empty--row" v-for="n in items.length < 1 ? 1 - items.length : 0 " :key="n"><td class="is-borderless"></td></tr>
              </tbody>
            </table>
            <div class="is-border-top" v-if="totalPage > 1 && nextPage">
              <a class="button is-light is-fullwidth has-text-grey" @click="loadMore(true)" v-if="!infiniteLoading">
                <span class="icon is-small is-size-6"><i class="fas fa-chevron-down"></i></span>
                <span class="is-size-6">Afficher la suite</span>
              </a>
              <div class="has-text-centered" v-else><img src="static/spinner2.svg" alt="spinner" style="height: 38px"></div>
            </div>
            <div v-show="!loading && !items.length">
              <div class="columns">
                <div class="column">
                  <h2 class="title is-3 has-text-weight-bold">Aucun Mandat disponible</h2>
                  <a class="has-text-primary" @click="resetFilters" v-if="hasFilter"><span class="icon is-small"><i
                    class="fal fa-undo-alt"></i></span> <span>Réinitialiser les filtres</span></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { GenericList, Filter, Sort, MultiSelection } from '../../mixins'
  import { mapGetters, mapState } from 'vuex'
  import { exportXls } from '../../utils'

  export default {
    name: 'AccessList',
    mixins: [GenericList, Filter, Sort, MultiSelection],
    data () {
      return {
        actionButtons: [
          {
            linkClass: ['button', 'is-red'],
            icon: ['fas', 'fa-trash-alt'],
            display: () => {
              return !this.multiselection
            },
            action: () => {
              this.deleteAccesses()
            },
            text: 'Supprimer les mandats courants'
          },
          {
            linkClass: ['button', 'is-red'],
            icon: ['fas', 'fa-trash-alt'],
            display: () => {
              return this.multiselection
            },
            action: () => {
              this.deleteSelectedAccesses()
            },
            text: 'Supprimer les mandats sélectionnés'
          }
        ],
        buttonList: [
          {
            action: (id) => {
              this.deleteItem(id)
            },
            icon: 'fa-trash',
            text: 'Supprimer',
            needProfile: ['admin']
          }
        ],
        enabledSaveSort: true,
        opened: true,
        service: this.$api.accessService,
        loadDocuments: this.loadItems,
        companies: [],
        query: {
          program: this.$route.query.program,
          end_date: this.$route.query.end_date
        },
        programs: [],
        promoteurs: [],
        configDate: {
          altFormat: 'j/m/Y',
          altInput: true,
          dateFormat: 'd/m/Y'
        },
        startDateOpened: false,
        startDateClosed: false,
        endDateOpened: false,
        endDateClosed: false,
        rangeDateOpened: false,
        rangeDateClosed: true,
        range_date: null,
        exportXls,
        askDelete: false,
        infiniteLoaderEnabled: true
      }
    },
    computed: {
      ...mapState({
        promoteursList: 'promoteurs',
        quickview: 'quickview',
        companiesList: 'companies'
      }),
      ...mapGetters(['displayRemuneration', 'isDistributeurMode', 'isAdmin'])
    },
    watch: {
      currentUserPreferences () {
        this.query.sort = this.currentUserPreferences[`sort-${this.$route.name}`]
        this.changeFilters()
      },
      selectedItems () {
        this.askDelete = false
      },
      quickview ({mode, params, results}) {
        if (results) {
          if (mode === 'EDIT_ACCESS') {
            let access = results
            this.$api.accessService.patch(access.pk, access).then(r => {
              this.items.find(x => {
                if (x.pk === results.pk) {
                  Object.assign(x, r.data)
                  this.$notify({
                    type: 'is-success',
                    text: 'Le mandat à été mis à jour.'
                  })
                }
              })
            }).catch(err => {
              console.log(err)
              this.$notify({
                type: 'is-danger',
                text: 'Erreur lors de la mise à jour du mandat.'
              })
            })
          }
        }
      }
    },
    methods: {
      companyName (value) {
        return value.name
      },
      deleteAccesses () {
        const d = {
          title: 'Suppression',
          text: 'Êtes vous sûr de vouloir supprimer ces mandats (' + this.total + ') ?',
          confirmButtonText: 'Supprimer'
        }
        this.$swal(d).then(r => {
          if (r.value) {
            this.$api.accessService.deleteMany(this.query).then(() => {
              this.$notify({
                type: 'is-success',
                text: 'Les mandats sont en cours de suppression.'
              })
              this.loadItems()
            }).catch(() => {
              this.$notify({
                type: 'is-danger',
                text: 'Erreur lors de la suppression des mandats.'
              })
            })
          }
        })
      },
      deleteSelectedAccesses () {
        this.$api.accessService.deleteMany({pk: this.selectedItems}).then(() => {
          this.$notify({
            type: 'is-success',
            text: 'Les mandats sont en cours de suppression.'
          })
          this.loadItems()
          this.clearSelectedItems()
          this.multiselection = false
        }).catch(() => {
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de la suppression des mandats.'
          })
        })
      },
      beforeGet () {
        if (!this.query.company) {
          this.query.company = undefined
        }
        if (this.query.company && typeof this.query.company === 'object') {
          this.query.company = this.query.company.pk
        }
        if (!this.query.program) {
          this.query.program = undefined
        }
        if (this.query.program && typeof this.query.program === 'object') {
          this.query.program = this.query.program.pk
        }
        if (!this.query.promoteur) {
          this.query.promoteur = undefined
        }
        if (this.query.promoteur && typeof this.query.promoteur === 'object') {
          this.query.promoteur = this.query.promoteur.pk
        }
      },
      updateCompanyFilter (e) {
        this.$set(this.filters, 'company', e)
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      updateProgramFilter (e) {
        this.$set(this.filters, 'program', e)
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      updatePromoteurFilter (e) {
        this.$set(this.filters, 'promoteur', e)
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      updateRangeDateFilter (e) {
        let range = e.split(' au ')
        this.$set(this.filters, 'start_date__gte', range[0])
        if (range.length > 0) this.$set(this.filters, 'end_date__lte', range[1])
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      getCompanies (query) {
        let filters = {}
        if (query) {
          filters['name'] = query
        }
        this.$api.companyService.get(filters).then(r => {
          this.companies = r.data.items
        })
      },
      getPrograms (query) {
        this.$api.programService.get({name: query}).then(r => {
          this.programs = r.data.items
        })
      },
      getPromoteurs (query) {
        this.$api.promoteurService.get({name: query}).then(r => {
          this.promoteurs = r.data.items
        })
      }
    },
    created () {
      if (this.currentUserPreferences) {
        this.query.sort = this.currentUserPreferences[`sort-${this.$route.name}`]
        this.changeFilters()
      } else {
        this.loadDocuments()
      }
      this.companies = this.companiesList.slice()
      this.getPrograms()
      if (this.isDistributeurMode) {
        this.promoteurs = this.promoteursList.slice()
      }
      if (this.$route.query.end_date) {
        this.query.end_date = this.$route.query.end_date
        this.filters.end_date__lte = this.$route.query.end_date
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/access/AccessList.vue